import { DragEndEvent } from '@dnd-kit/core';
import * as yup from 'yup';

export const draggableImageDataSchema = yup
  .object({
    id: yup.string().required(),
    url: yup.string().required(),
  })
  .required();

export const droppableImageSlotDataSchema = yup
  .object({
    id: yup.string().required(),
    imageSlotIndex: yup.number().required(),
    image: yup
      .object({
        id: yup.string().required(),
        url: yup.string().required(),
        name: yup.string().required(),
      })
      .default(null)
      .nullable(),
    images: yup
      .array(
        yup.object({
          id: yup.string().required(),
          url: yup.string().required(),
          name: yup.string().required(),
        }),
      )
      .required(),
  })
  .required();

export const sortableImageDataSchema = droppableImageSlotDataSchema.concat(
  yup
    .object({
      sortable: yup
        .object({
          containerId: yup.string().required(),
          items: yup.array(yup.string().required()).required(),
          index: yup.number().required(),
        })
        .required(),
    })
    .required(),
);

export type DraggableImageData = yup.InferType<typeof draggableImageDataSchema>;
export type SortableImageData = yup.InferType<typeof sortableImageDataSchema>;
export type DroppableImageSlotData = yup.InferType<typeof droppableImageSlotDataSchema>;

export const isDraggableImageData = (item: unknown): item is DraggableImageData =>
  draggableImageDataSchema.isValidSync(item);

export const isDroppableImageSlotData = (item: unknown): item is DroppableImageSlotData =>
  droppableImageSlotDataSchema.isValidSync(item);

export type CustomDragEndEvent<A, O> = Omit<DragEndEvent, 'active' | 'over'> & {
  active: {
    data: {
      current: A;
    };
  };
  over: {
    data: {
      current: O;
    };
  };
};

export const isReorderEvent = (event: any): event is CustomDragEndEvent<SortableImageData, SortableImageData> =>
  sortableImageDataSchema.isValidSync(event.active?.data.current) &&
  droppableImageSlotDataSchema.isValidSync(event.over?.data.current);

export const isLinkImageEvent = (event: any): event is CustomDragEndEvent<DraggableImageData, DroppableImageSlotData> =>
  isDroppableImageSlotData(event.over?.data.current) && isDraggableImageData(event.active?.data.current);
